<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Open Category COE Transfer</h1>
    <app-navpath />
  </div>
  <section class="content-container">
    <h2 class="sub-heading w-full border-b">
      Open Category COE Transfer
    </h2>
    <app-data-form
      [dataFields]="OpenCategoryCOETransfer"
      [dataName]="'OpenCategoryCOETransfer'"
      (updateFields_child)="updateFields($event)"
      (clickSearch)="searchNumber($event)"
    />
  </section>
  <section class="content-container">
    <div class="flex w-full justify-between border-b">
      <h2 class="sub-heading">Select a COE</h2>
      <button class="shorter-btn misc-btn" (click)="openSearchCOE()">
        <fa-icon [icon]="faPlus" class="mr-1" />Select a COE
      </button>
    </div>
    <app-data-form
      [dataFields]="SelectCOE"
      [dataName]="'SelectCOE'"
      (updateFields_child)="updateFields($event)"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn save-btn"
        [disabled]="!AllowUpdate"
        (click)="update()"
      >
        <fa-icon [icon]="faPencil" class="mr-1" />Update
      </button>
      <button
        class="shorter-btn print-btn"
        (click)="ShowPrint = true"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button class="shorter-btn print-btn" (click)="printSlip()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print Slip
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="!AllowDrop"
        (click)="dropAllocation()"
      >
        <fa-icon [icon]="faTrash" class="mr-1" />Drop Allocation
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faEraser" class="mr-1" />Clear
      </button>
    </div>
  </section>
  <section class="content-container" *ngIf="ShowSearchCOE">
    <h2 class="sub-heading w-full border-b">Search COE</h2>
    <app-data-form
      [dataFields]="SearchCOE"
      [dataName]="'SearchCOE'"
      (updateFields_child)="updateFields($event)"
    />
    <app-data-table
      [tableHeaders]="TableHeaders"
      [pagination]="false"
      [tableEntries]="TableEntries"
      (edit)="selectCOE($event)"
      *ngIf="TableEntries.length > 0"
    />
  </section>
  <section class="content-container" *ngIf="ShowPrint">
    <h2 class="sub-heading w-full border-b">Print Options</h2>
    <app-data-form
      [dataFields]="PrintOptions"
      [dataName]="'PrintOptions'"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn save-btn" (click)="printReport()">
        Ok
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="ShowPrint = false"
      >
        Cancel
      </button>
    </div>
  </section>
</section>
